import { render, staticRenderFns } from "./manageCategoryIndex.pug?vue&type=template&id=9a94862c&lang=pug&"
import script from "./manageCategoryIndex.ts?vue&type=script&lang=ts&"
export * from "./manageCategoryIndex.ts?vue&type=script&lang=ts&"
import style0 from "./manageCategoryIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports